import React from 'react';
import { motion } from 'framer-motion';
import { Monitor, Home, Car, Calendar, ExternalLink, ArrowRight } from 'lucide-react';

// Cards are a fixed height, so only the first few features are shown.
const MAX_FEATURES = 4;

const iconMap = {
  Monitor,
  Home, 
  Car,
  Calendar
};

const ServiceCard = ({ service, index }) => {
  const IconComponent = iconMap[service.icon];
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 90 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ 
        duration: 0.8, 
        delay: index * 0.1,
        ease: [0.4, 0, 0.2, 1] 
      }}
      whileHover={{ 
        y: -4,
        transition: { duration: 0.2 }
      }}
      className="design-card service-card"
    >
      <div className="card-banner">
        <img
          src={`${process.env.PUBLIC_URL}${service.image}`}
          alt=""
          loading="lazy"
          width="800"
          height="400"
        />
        <div className={`card-icon ${service.color === 'accent' ? 'bg-accent' : 'bg-primary'}`}>
          <IconComponent size={32} color="white" />
        </div>
      </div>

      <div className="card-body">
      
      <h3 className="card-title">{service.name}</h3>
      <p className="card-description">{service.description}</p>
      
      <div className="service-features">
        {service.features.slice(0, MAX_FEATURES).map((feature, idx) => (
          <span key={idx} className="feature-tag">
            {feature}
          </span>
        ))}
      </div>
      
        <a
          className="card-action"
          href={service.website}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Visit ${service.name} — opens in a new tab`}
        >
          <span className="visit-text">Visit Website</span>
          <div className="action-icon">
            <ArrowRight size={20} />
          </div>
        </a>
      </div>
    </motion.div>
  );
};

export default ServiceCard;